import React from 'react';

const ClimateCitizenTheme = {
  headerLogo: {
    src: '/themes/theme/climate-citizen/logo.png',
    alt: 'Climate Citizen',
  },
  darkLogo: {
    src: '/themes/theme/climate-citizen/logo-black-text.png',
    alt: 'Climate Citizen',
    size: 80,
  },
  headerStyle: {
    backgroundColor: '#1d1937',
    borderBottom: '2px solid #37B2AB',
  },
  linkStyle: {
    color: '#DDD',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'CLIMATE CITIZEN',
  isLightOnDark: true,
  organisationId: '6990ac5d-f654-47cb-98d4-c43ca7ac1225',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br />
      <br />
      <img height="50" src="/themes/theme/climate-citizen/logo-black-text.png" alt="Climate Citizen" />
      <br />
      <br />
      <p style={{ fontSize: 'large' }}>Automated Influencer Tracking</p>
      <hr />
    </div>
  ),
  shareSite: 'https://climate-citizenr.dyzio.co',
};

export default ClimateCitizenTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/climate-citizen.js
 **/